import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import { useFeatures } from 'flagged'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Box, Button, Card, CardContent, TextField } from '../../../../components/mui/Core/index'
import { ForgotPassword } from '../../../../api/userauthentication/forgotpassword'
import { GenericSnackbar } from '../../../../components/GenericSnackbar/generic-snackbar'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import awsconfig from '../../../../aws-exports'
import useBrowserTabTitles from '../../../../hooks/browserTabTitles/browser-tab-titles'
import * as Constants from '../../../../constants/en.json'
import { resetPasswordRequest } from '../../../../api/user/forgot-password'
import { setSnackbar } from '../../../../components/GenericSnackbar/generic-snackbar-slice'

Amplify.configure(awsconfig)

function ResetPassword() {
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const features = useFeatures()
  const isUserServiceEnabled = features.isUserServiceEnabled
  const [formData, setFormData] = useState({})
  const [emailAddress, setEmailAddress] = useState('')

  const handleSubmitForgotPasswordRequest = () => {
    if (!isUserServiceEnabled) {
      ForgotPassword(formData)
        .then(() => {
          navigate('/reset-password-sent')
        })
        .catch(() => {
          dispatch(
            setSnackbar({
              message: 'Failed to submit password reset request',
              severity: 'error',
              action: true,
            }),
          )
        })
    } else {
      resetPasswordRequest(formData)
        .then(() => {
          navigate('/reset-password-sent')
        })
        .catch(() => {
          dispatch(
            setSnackbar({
              message: 'Failed to submit password reset request',
              severity: 'error',
              action: true,
            }),
          )
        })
    }
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      handleSubmitForgotPasswordRequest()
    }
  }

  // This is passed as a prop to the button component. If no username or no password is entered, the Login button is disabled.
  // In Buttons.jsx, you will see {...props} as a property of the button. This is where the disabled property is stored and being read from.
  const isFormValid = !emailAddress

  useBrowserTabTitles(Constants.resetPassword.RESET_PASSWORD)

  useEffect(() => {
    setFormData({
      email: emailAddress,
    })
  }, [emailAddress])

  const resetPasswordBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
  const emailTextFieldStyle = { width: '240px' }
  const passwordResetButtonStyle = {
    mt: 3,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  }

  return (
    <>
      <Box sx={theme.soloContainer}>
        <Card className='soloCard'>
          <CardContent>
            <Box sx={resetPasswordBoxStyle}>
              <FormHeading formHeader='Reset Password' />
              <TextField
                onChange={(e) => setEmailAddress(e.target.value)}
                onKeyDown={(e) => handleKeyPress(e)}
                required
                id='outlined-basic-email'
                label={Constants.resetPassword.EMAIL}
                variant='outlined'
                type='email'
                placeholder={Constants.resetPassword.ENTER_EMAIL_ADDRESS}
                sx={emailTextFieldStyle}
              />
              <Button
                onClick={handleSubmitForgotPasswordRequest}
                variant='contained'
                formdata={formData}
                disabled={isFormValid}
                sx={passwordResetButtonStyle}
              >
                {Constants.forgotPassword.SEND_RESET_REQUEST}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <GenericSnackbar />
    </>
  )
}

export default ResetPassword
